<script lang="ts">
	import ReportModal from './../../../../../../custom/Comments/components/Comment/components/ReportModal.svelte';
  import { list, pagination, currentPage, isShowDeleteModal, deletePublicationId } from '../../store'
  import { changePagination, deletePublication, copyPublication, openDeleteModal, closeDeleteModal } from '../../services'
  import { link, push } from 'svelte-spa-router'

  import EyeIcon from '../../../../../../../../public/svg/table-eye.svg'
  import CalendarIcon from '../../../../../../../../public/svg/table-calendar.svg'
  import PencilIcon from '../../../../../../../../public/svg/table-pencil.svg'
  import TrashIcon from '../../../../../../../../public/svg/table-trash.svg'
  import CopyIcon from '../../../../../../../../public/svg/copy-icon.svg'
  import DateComponent from '../../../../../../custom/DateComponent.svelte'
  import Status from './components/Status/Status.svelte'
  import Pagination from '../../../../../../custom/Pagination.svelte'
  import MoreItems from './components/MoreItems/MoreItems.svelte'
</script>
<table>
  <thead>
    <tr>
      <td>Название постов</td>
      <td></td>
      <td>Статус</td>
      <td>Дата выхода</td>
      <td>Группа</td>
      <td>Поток</td>
      <td>Раздел</td>
      <td>Тэги</td>
      <td></td>
    </tr>
  </thead>
  <tbody>
    {#each $list as item (item.pk)}
      <tr>
        <td>
          <a class="item-title" use:link href="/editor/edit/{item.pk}/">
            {item.title}
          </a>
        </td>
        <td>
          {#if item.fix}
            <i class="icon-pin" />
          {/if}
        </td>
        <td>
          <Status status={item.status} />
        </td>
        <td>
          {#if item.activate_event_date}
            <DateComponent createdDate={item.activate_event_date} />
          {:else}
            -
          {/if}
        </td>
        <td>
          {item.feed_group_title || '-'}
        </td>
        <td>
          {#if item.flows_title_list.length}
            <MoreItems moreItems={item.flows_title_list} />
          {:else}
            -
          {/if}
        </td>
        <td>
          {#if item.section_title_list.length}
            <MoreItems moreItems={item.section_title_list} />
          {:else}
            -
          {/if}
        </td>
        <td>
          {#if item.feed_tag_title_list.length}
            <MoreItems moreItems={item.feed_tag_title_list} />
          {:else}
            -
          {/if}
        </td>
        <td>
          <div class="icons">
            <a use:link href="/editor/schedule/{item.pk}/">
              <CalendarIcon />  
            </a>
            <a use:link href="/editor/edit/{item.pk}/">
              <PencilIcon />  
            </a>
            <button type="button" on:click={() => copyPublication(item.pk)}>
              <CopyIcon />
            </button>
            <a use:link href="/preview_publ_from_list/{item.pk}">
              <EyeIcon />
            </a>
            <button type="button" on:click={() => openDeleteModal(item.pk)}>
              <TrashIcon />  
            </button>
          </div>
        </td>
      </tr>
    {/each}
  </tbody>
</table>

{#if $pagination}
  <div class="pagination">
    <Pagination 
      currentPage={$currentPage}
      pagination={$pagination}
      on:change-page={changePagination} 
    />
  </div>
{/if}

{#if $isShowDeleteModal}
  <ReportModal 
    title="Ты уверен, что хочешь удалить пост?" 
    subtitle="" 
    onlyFirstScreen
    on:report={closeDeleteModal} 
  />
{/if}

<style lang="scss">
  .item-title {
    cursor: pointer;
    text-decoration: none;
  }
  
  .icon-pin {
    color: #0C8C6D;
    font-size: 14px;
  }

  * {
    font-size: 14px;
    line-height: 20px;
    color: #5A5F6D;
    box-sizing: border-box;
  }

  .pagination {
    margin-top: 36px;
    margin-bottom: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  table {
    border-spacing: 0;
    border-collapse: collapse;
    width: 100%;
    margin-top: 24px;
    table-layout: fixed;

    .icons {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      align-items: center;
      cursor: pointer;

      button, a {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 8px;
        padding: 0;
        background-color: transparent;
        border: none;
        cursor: pointer;
      }
    }

    thead {
      tr {
        td {
          background: #F9FAFB;
          border-bottom: 1px solid #EFF1FD;
          font-size: 12px;
          color: #5A5F6D99;
          font-weight: bold;
        }
      }
    }

    tbody {
      tr {
        td {
          border-bottom: 1px solid #D6DCFF;

          &:first-child {

            div {
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }
        }
      }
    }

    td {
      padding: 16px;
    }

    td {
      &:first-child {
        width: 195px;
      }

      &:nth-child(2) {
        width: 50px;
      }

      &:nth-child(3) {
        width: 160px;
      }

      &:nth-child(4) {
        width: 180px;
      }

      &:nth-child(5) {
        width: 119px;
        word-break: initial;
      }

      &:nth-child(6) {
        width: 100px;
      }

      &:nth-child(8) {
        width: 120px;
      }
    }
  }
</style>